<template>
  <div class="addTherapiesDialog" @contextmenu.prevent>
    <el-dialog
      title="治疗项目信息模板"
      :visible.sync="dialogStatus"
      width="1205px"
      class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
    >
      <div class="navBorder"></div>
      <div class="main">
        <el-form :rules="rules" ref="ruleForm" :model="theRapies"
                 @keydown.native.enter.prevent="">
          <div class="left">
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">
                  美容/治疗项目
                  <el-popover
                    placement="top-start"
                    title="帮助"
                    width="200"
                    trigger="hover"
                    content="当右侧的模板列表中，已经存在输入的项目名称，则会在该项目下自动添加，否则为新增项目"
                  >
                    <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
                  </el-popover>
                </p>

                <el-form-item prop="beauty_item">
                  <el-input
                    class="popInput popInputSingle"
                    v-model="theRapies.beauty_item"
                    placeholder="请输入内容"
                    placement="top"
                    :disabled="dblLevel!==1&&isReset"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">治疗设备/方法</p>
                <el-form-item prop="therapeutic_methods">
                  <el-input
                    class="popInput popInputSingle"
                    v-model="theRapies.therapeutic_methods"
                    placeholder="请输入内容"
                    placement="top"
                    :disabled="dblLevel!==2&&isReset"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">治疗模块/药物</p>
                <el-form-item prop="therapeutic_module">
                  <el-input
                    class="popInput popInputSingle"
                    v-model="theRapies.therapeutic_module"
                    placeholder="请输入内容"
                    placement="top"
                    :disabled="dblLevel!==3&&isReset"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="leftItem">
                <p class="rightItemTitle popTitleDialog">参数名称（名称间以“#”分隔）</p>
                <div class="leftBox">
                  <el-form-item prop="arguments">
                    <el-input
                      class
                      placeholder="请输入内容"
                      placement="top"
                      v-model="theRapies.arguments"
                      type="textarea"
                      :disabled="dblLevel!==4&&isReset"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <button
                  @click.prevent="resetForm()"
                  class="btn iconfont leftItemSubmit"
                  style="padding: 0"
                >重置</button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <button
                  @click.prevent="getData('ruleForm')"
                  class="btn iconfont leftItemSubmit"
                  style="padding: 0"
                >{{submitText}}</button>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
        <div class="right">
          <div class="rightItem">
            <p class="rightItemTitle popTitleDialog">
              模板列表
              <el-popover
                placement="top-start"
                title="帮助"
                width="200"
                trigger="hover"
                content="单击可展开/收起列表，双击可在左侧输入框中进行编辑，鼠标点击右侧悬浮按钮进行删除（可删除对应的治疗模板及其下的子模板）或添加（添加对应治疗模板下的子模板）"
              >
                <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
              </el-popover>
            </p>
          </div>
          <div class="rightBox my_tree">
            <el-input class="popInput rightInput" placeholder="关键词搜索" v-model="filterText"></el-input>

            <el-tree
              class="filter-tree"
              :data="data"
              :props="defaultProps"
              default-expand-all
              :filter-node-method="filterNode"
              :render-content="renderContent"
              highlight-current
              @node-drop="sort"
              ref="tree"
              style="height: 600px;overflow-y: auto;"
            ></el-tree>
            <!-- draggable // 暂时隐藏拖拽功能 -->

            <!-- <v-jstree :data="data" draggable no-dots allow-transition @item-click="itemClick" :item-events="itemEvents"></v-jstree> -->
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// https://github.com/zdy1988/vue-jstree/blob/HEAD/README-CN.md
// https://blog.csdn.net/weixin_42727550/article/details/89878685
import moment from "moment";
import _ from "lodash";
import api from "../api";
import addCosmetologyItem from "../gql/addCosmetologyItem.gql";
import getCosmetologyItemTree from "../gql/getCosmetologyItemTree.gql";
import removeCosmetologyModuleList from "../gql/removeCosmetologyModuleList.gql";
import modifyCosmetologyModuleList from "../gql/modifyCosmetologyModuleList.gql";
let template = {};
let time = null;
export default {
  name: "inHospitalDialog",

  inject: {
    getHairdressingTree: ["getHairdressingTree"]
  },

  data() {
    const therapeutic_methods = (rule, value, callback) => {
      if (value === "") {
        if (this.theRapies.therapeutic_module) {
          callback(new Error("请输入内容"));
        }
        callback();
      } else {
        callback();
      }
    };

    return {
      theRapies: {
        beauty_item: "",
        therapeutic_methods: "",
        therapeutic_module: "",
        arguments: ""
      },
      submitText: "保存",
      toDialoPatientsData: {},
      filterText: "",
      data: [],
      dblLevel: 5,
      isReset: false,
      resetId: -1,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 初始化id
      defaultProps2: {
        id: 0
      },
      // 选中的树结构id
      selectIdArray: [],
      rules: {
        therapeutic_methods: [
          { validator: therapeutic_methods, trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ]
     /*   beauty_item: [
          { message: "请输入内容", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ],
        therapeutic_methods: [
          { validator: therapeutic_methods, trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ],
        therapeutic_module: [
           { required: true, message: "请输入内容", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ],
        arguments: [
           { required: true, message: "请输入内容", trigger: "blur" },
          {
            min: 1,
            max: 300,
            message: "长度在 1 到 300 个字符",
            trigger: "blur"
          }
        ]*/
      }
    };
  },
  computed: {
    dialogStatus: {
      get() {
        return this.therapiesStatus;
      },
      set(val) {
        this.$emit("setTherapiesStatus", val);
        if (this.therapiesStatus) {
          this.resetForm();
        }
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  props: {
    therapiesStatus: {
      type: Boolean,
      default: () => false
    }
  },
  async mounted() {
    await this.getCosmetologyItemTreeData();
  },
  methods: {
    setRules() {
      // let rule1 = this.dblLevel !== 1 && this.isReset;
      // let rule2 = this.dblLevel !== 2 && this.isReset;
      // let rule3 = this.dblLevel !== 3 && this.isReset;
      // let rule4 = this.dblLevel !== 4 && this.isReset;
      // if (!rule2) {
      //   this.rules.therapeutic_module[0].required = false;
      //   this.rules.arguments[0].required = false;
      // }
      // if (!rule3) {
      //   this.rules.arguments[0].required = false;
      // }
    },
    resetRules() {
      // this.rules.beauty_item[0].required = true;
      // this.rules.therapeutic_methods[0].required = true;
      // this.rules.therapeutic_module[0].required = true;
      // this.rules.arguments[0].required = true;
    },
    sort(draggingNode, dropNode, type, event) {
      console.log("排序", draggingNode);
      console.log("排序", dropNode);
      console.log("排序", type);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === 1) {
        return type === "prev";
      } else {
        return false;
      }
    },
    // 获取输入值
    getData(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.theRapies.beauty_item === ""){
            this.theRapies.beauty_item ="NA"
          }
          // this.addNewTree();
          if (this.isReset) {
            if (this.resetId > -1) {
              let content = "";
              if (this.dblLevel === 1) {
                content = this.theRapies.beauty_item;
              } else if (this.dblLevel === 2) {
                content = this.theRapies.therapeutic_methods;
              } else if (this.dblLevel === 3) {
                content = this.theRapies.therapeutic_module;
              } else if (this.dblLevel === 4) {
                content = this.theRapies.arguments;
              }
              await this.setmodifyCosmetologyModuleList(
                this.dblLevel,
                this.resetId,
                content
              );
            }
          } else {
            await this.saveCosmetologyImages();
          }
          this.resetForm();
          await this.getCosmetologyItemTreeData();
          this.$root.$emit("refresh-par-num-list");
        } else {
          return false;
        }
      });
    },
    async saveCosmetologyImages() {
      try {
        let res = await this.$apollo.mutate({
          mutation: addCosmetologyItem,
          variables: {
            item: this.theRapies.beauty_item,
            device: this.theRapies.therapeutic_methods,
            treat_module: this.theRapies.therapeutic_module,
            params: this.theRapies.arguments
          }
        });
        this.$message.success("数据已保存");
        this.getHairdressingTree();
      } catch (error) {
        console.log(error);
      }
    },
    computedTree(treeData) {
      if (!_.isEmpty(treeData)) {
        treeData.map(e => {
          e.label = e.item_name;
          e.children = [];
          e.delete = false;
          e.addChild = true;
          e.device.map(m => {
            m.label = m.device_name;
            m.node = true;
            m.delete = false;
            m.addChild = true;
            m.children = [];
            m.treat_module.map(n => {
              n.label = n.module_name;
              n.node = true;
              n.delete = false;
              n.addChild = false;
              n.children = [];
              n.children = [
                {
                  id: n.id,
                  label: n.params,
                  delete: true,
                  dis: true,
                  addChild: false
                }
              ];
            });
            m.children = m.treat_module;
          });
          e.children = e.device;
        });
        return treeData;
      } else {
        return [];
      }
    },
    async getCosmetologyItemTreeData() {
      try {
        let res = await this.$apollo.query({
          query: getCosmetologyItemTree,
          fetchPolicy: "no-cache"
        });
        this.data = this.computedTree(res.data.getCosmetologyItemTree);
      } catch (error) {
        console.log(error);
      }
    },
    async removeCosmetologyItem(Type, ID) {
      try {
        let res = await this.$apollo.mutate({
          mutation: removeCosmetologyModuleList,
          variables: {
            mtype: Type,
            id: ID
          }
        });
        this.$message.success("数据已删除");
        this.getHairdressingTree();
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    async setmodifyCosmetologyModuleList(Type, ID, Content) {
      try {
        let res = await this.$apollo.mutate({
          mutation: modifyCosmetologyModuleList,
          variables: {
            mtype: Type,
            id: ID,
            content: Content
          }
        });
        this.$message.success("数据已修改");
        this.getHairdressingTree();
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    addNewTree() {
      this.data2 = [];
      let datas = this.data;
      // 当树为空
      if (_.isEmpty(this.data)) {
        this.addNewTreeMethods();
      } else {
        if (!_.isEmpty(this.selectIdArray)) {
          this.resetTreeDataMethods();
          if (this.selectIdArray.length === 1) {
            let item = this.data.find(e => {
              return e.id === this.selectIdArray[0];
            });
            if (this.theRapies.therapeutic_methods) {
              const newChild2 = {
                id: ++this.defaultProps2.id,
                label: this.theRapies.therapeutic_methods,
                delete: false,
                node: true,
                children: []
              };
              if (this.theRapies.therapeutic_module) {
                const newChild3 = {
                  id: ++this.defaultProps2.id,
                  label: this.theRapies.therapeutic_module,
                  delete: false,
                  node: true,
                  children: []
                };
                if (this.theRapies.arguments) {
                  const newChild4 = {
                    id: ++this.defaultProps2.id,
                    label: this.theRapies.arguments,
                    delete: false,
                    node: true,
                    dis: true,
                    children: []
                  };
                  newChild3.children.push(newChild4);
                }
                newChild2.children.push(newChild3);
              }
              if (_.isEmpty(item.children)) {
                item.children = [];
              }
              item.children.push(newChild2);
            }
          }
          if (this.selectIdArray.length === 2) {
            let item = this.data.find(e => {
              return e.id === this.selectIdArray[0];
            });
            let item2 = item.children.find(e => {
              return e.id === this.selectIdArray[1];
            });
            if (this.theRapies.therapeutic_module) {
              const newChild3 = {
                id: ++this.defaultProps2.id,
                label: this.theRapies.therapeutic_module,
                delete: false,
                node: true,
                children: []
              };
              if (this.theRapies.arguments) {
                const newChild4 = {
                  id: ++this.defaultProps2.id,
                  label: this.theRapies.arguments,
                  delete: false,
                  node: true,
                  dis: true,
                  children: []
                };
                newChild3.children.push(newChild4);
              }
              if (!item2.children) {
                item2.children = [];
              }
              item2.children.push(newChild3);
            }
          }
          if (this.selectIdArray.length === 3) {
            let item = this.data.find(e => {
              return e.id === this.selectIdArray[0];
            });
            let item2 = item.children.find(e => {
              return e.id === this.selectIdArray[1];
            });
            let item3 = item2.children.find(e => {
              return e.id === this.selectIdArray[2];
            });
            if (this.theRapies.arguments) {
              const newChild4 = {
                id: ++this.defaultProps2.id,
                label: this.theRapies.arguments,
                delete: false,
                node: true,
                dis: true,
                children: []
              };
              if (!item3.children) {
                item3.children = [];
              }
              item3.children.push(newChild4);
            }
          }
        } else {
          this.addNewTreeMethods();
        }
      }
    },
    resetTreeDataMethods() {
      // 修改
      let setItemData = this.data;
      for (let i = 0; i < this.selectIdArray.length; i++) {
        let item = setItemData.find(e => {
          return e.id === this.selectIdArray[i];
        });
        if (i === 0) {
          item.label = this.theRapies.beauty_item;
        } else if (i === 1) {
          item.label = this.theRapies.therapeutic_methods;
        } else if (i === 2) {
          item.label = this.theRapies.therapeutic_module;
        } else if (i === 3) {
          item.label = this.theRapies.arguments;
        }
        setItemData = item.children;
      }
     
    },
    addNewTreeMethods() {
      // 0新增
      const newChild1 = {
        id: ++this.defaultProps2.id,
        label: this.theRapies.beauty_item,
        delete: false,
        children: []
      };
      if (this.theRapies.therapeutic_methods) {
        const newChild2 = {
          id: ++this.defaultProps2.id,
          label: this.theRapies.therapeutic_methods,
          delete: false,
          node: true,
          children: []
        };
        if (this.theRapies.therapeutic_module) {
          const newChild3 = {
            id: ++this.defaultProps2.id,
            label: this.theRapies.therapeutic_module,
            delete: false,
            node: true,
            children: []
          };
          if (this.theRapies.arguments) {
            const newChild4 = {
              id: ++this.defaultProps2.id,
              label: this.theRapies.arguments,
              delete: false,
              node: true,
              dis: true,
              children: []
            };
            newChild3.children.push(newChild4);
          }
          newChild2.children.push(newChild3);
        }
        newChild1.children.push(newChild2);
      }
      this.data.push(newChild1);
    },
    append(data) {
      const newChild = { id: id++, label: "testtest", children: [] };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
    },
    resetForm() {
      this.theRapies.beauty_item = "";
      this.theRapies.therapeutic_methods = "";
      this.theRapies.therapeutic_module = "";
      this.theRapies.arguments = "";
      this.selectIdArray = [];
      this.isReset = false;
      this.dblLevel = 5;
      this.resetId = -1;
      this.resetRules();
      let key = "ruleForm";
      this.$refs[key].resetFields();
    },
    writeForm(array) {
      for (let i = 0; i < array.length; i++) {
        this.$set(this.theRapies, "beauty_item", array[0]);
        this.$set(this.theRapies, "therapeutic_methods", array[1]);
        this.$set(this.theRapies, "therapeutic_module", array[2]);
        this.$set(this.theRapies, "arguments", array[3]);
      }
    },
    closeDialog() {
      return;
    },
    getParientsData(Vnode) {
      if (Vnode) {
        let array = [];
        this.selectIdArray = [];
        const aa = data => {
          array.unshift(data.label);
          this.selectIdArray.unshift(data.id);
          if (data.level > 1) {
            aa(data.parent);
          }
        };
        aa(Vnode);
    
   /*     if (Vnode.level === 1 && !_.isEmpty(Vnode.childNodes)) {
          console.log(array)
          array.push(Vnode.childNodes[0].label);
          this.selectIdArray.push(Vnode.childNodes[0].id);
        }
        if (Vnode.level === 2 && !_.isEmpty(Vnode.childNodes)) {
          console.log(array)
          array.push(Vnode.childNodes[0].label);
          this.selectIdArray.push(Vnode.childNodes[0].id);
        }*/
        if (Vnode.level === 3 && !_.isEmpty(Vnode.childNodes)) {
  
          array.push(Vnode.childNodes[0].label);
          this.selectIdArray.push(Vnode.childNodes[0].id);
        }
        return array;
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
    // https://blog.csdn.net/kkae8643150/article/details/52910389
    renderContent(createElement, { node, data, store }) {
      return createElement(
        "span",
        {
          attrs: {
            style: (() => {
              if (data.dis === true) {
                return "flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px";
              } else if (data.node === true) {
                if (!data.children || data.children.length === 0) {
                  return "flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 19px";
                } else {
                  return "flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default";
                }
              } else {
                return "flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default";
              }
            })()
          },
          on: {
            click: event => {
              event.stopPropagation();
              // 取消上次延时未执行的方法
              clearTimeout(time);
              // 执行延时
              time = setTimeout(() => {
                // do function在此处写单击事件要执行的代码
                node.expanded ? node.collapse() : node.expand();
              }, 300);
            },
            mouseenter: event => {
              if (event.button === 2) {
                event.stopPropagation();
                event.preventDefault();
              }
              data.delete = true;
            },
            mouseleave: event => {
              if (event.button === 2) {
                event.stopPropagation();
                event.preventDefault();
              }
              data.delete = false;
            }
          }
        },
        [
          createElement(
            "div",
            {
              attrs: {
                style: (() => {
                  if (data.dis === true) {
                    return "flex:1;color: #444;font-size: 12px;user-select: none;line-height:16px;";
                  } else {
                    return "flex:1";
                  }
                })(),
                class: "node"
              },
              on: {
                dblclick: event => {
                  // 双击将病名或模板添加到对应位置
                  event.stopPropagation();
                  // 取消上次延时未执行的方法
                  clearTimeout(time);
                  this.resetForm();
                  this.resetRules();
                  this.dblLevel = node.level;
                  this.isReset = true;
                  this.resetId = node.data.id;
                  this.writeForm(this.getParientsData(node));
                  this.setRules();
                }
              }
            },
            node.label
          ),
          createElement("i", {
            attrs: {
              class: (() => {
                if (data.addChild && data.delete) {
                  return "el-icon-plus themeColorAdd themeColorPop";
                } else {
                  return "";
                }
              })()
            },
            on: {
              click: event => {
                event.stopPropagation();
                this.resetForm();
                this.resetRules();
                this.writeForm(this.getParientsData(node));
                this.setRules();
              }
            }
          }),
          createElement("i", {
            attrs: {
              class: (() => {
                if (data.dis === true) {
                  return "";
                } else {
                  if (data.delete) {
                    return "el-icon-delete themeColorDelete themeColorPop";
                  } else {
                    return "";
                  }
                }
              })()
            },
            on: {
              click: event => {
                event.stopPropagation();
                this.$confirm(
                  "此操作将永久删除该模板，且绑定该治疗模板的标记点数据不再显示, 是否继续?",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  }
                )
                  .then(async () => {
                    let isSuccess = await this.removeCosmetologyItem(
                      node.level,
                      node.data.id
                    );
                    if (isSuccess) {
                      this.resetForm();
                      this.$refs.tree.remove(node);
                      this.$root.$emit("refresh-par-num-list");
                    } else {
                      this.$message.error("请重试");
                    }
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除"
                    });
                  });
              }
            }
          })
        ]
      );
    }
  }
};
</script>
<style lang="less">
.addTherapiesDialog {
  /*修改tree插件样式*/
  .my_tree .el-tree-node__content {
    height: auto;
  }
  .my_tree .el-tree-node {
    white-space: pre-wrap;
    padding: 0;
  }
  .my_tree .v-modal {
    z-index: 0 !important;
  }
  .my_tree .el-tree-node__expand-icon {
    margin-left: 6px;
    margin-right: 6px;
    padding: 0;
    font-size: 24px;
    color: #111;
  }
  .my_tree .is-leaf.el-tree-node__expand-icon {
    color: rgba(255, 255, 255, 0);
    display: none;
  }
  .el-tree-node__content:hover {
    background-color: #66b1ff87;
  }
  .el-textarea__inner {
    height: 249px;
    margin: 4px;
    border: 0;
    width: 98%;
    box-sizing: border-box;
  }
}
</style>
<style lang="less">
.addTherapiesDialog {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .dialog-pic .el-dialog__header {
    padding-bottom: 28px;
  }
  .themeColorDelete {
    color: red !important;
  }
  .themeColorAdd {
    color: #4da3c0 !important;
  }
  .themeColorPop {
    margin-left: 10px;
    transform: scale(1.2);
    font-weight: 700;
    margin-right: 5px;
  }
  .BtnScale {
    transform: scale(1.5);
  }
  .textareas {
    height: 619px !important;
  }
  .el-dialog__wrapper{
    display: block;
  }
}
</style>
<style lang="less" scoped>
.addTherapiesDialog {
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .dialog {
    min-width: 1205px;
    display: flex;
    align-items: center;
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
    }
  }
  .main {
    width: 100%;
    display: flex;
    padding: 0 16px;
    box-sizing: border-box;
    justify-content: space-between;
    .popInput {
      // width: 294px;
      border: 1px solid #c0c0c0 !important;
      border-radius: 8px;
      height: 48px;
      box-sizing: border-box;
    }
    .left {
      width: 650px;
      display: inline-block;

      .popInputSingle {
        width: 619px !important;
      }
      .leftItemSubmit {
        width: 298px;
        height: 42px;
        margin-top: 34px;
      }
      .isBW {
        display: flex;

        .isBWItem {
          flex: 1;
          font-size: 20px !important;
          font-weight: 600;
        }
        .activeBW {
          background: white;
          color: black;
        }
      }
    }
    .right {
      display: inline-block;
      .rightItem {
        .rightItemContent {
          position: relative;
          border: 10px solid white;
          width: 475px;
          height: 333px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .images-wrap {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background-color: rgb(235, 235, 235);
            padding: 10px 5px 10px 20px;
            overflow-y: auto;
            .images-list {
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              .image-item {
                width: 135px;
                height: 135px;
                margin-right: 4px;
                margin-bottom: 8px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
              }
              .image-item:nth-child(3n) {
                margin-right: 0;
              }
            }
            .add-btn {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              width: 414px;
              height: 60px;
              border: 3px dashed #fff;
              box-sizing: border-box;
              font-size: 22px;
              cursor: pointer;
            }
          }
          .rightItemIcon {
            font-size: 165px;
            color: white;
          }
        }
      }
      .inpatInput,
      .outpatInput {
        display: none;
      }
    }
  }
}
.icon-wrapper {
  position: fixed;
  width: 100px;
  background-color: rgb(97, 161, 191);
  border-radius: 3px;
  overflow: hidden;
  z-index: 2;
  .btn-item {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    cursor: pointer;
    user-select: none;
  }
  .btn-item.iconfont {
    font-size: 20px;
  }
  .btn-item.active {
    color: rgb(216, 30, 6);
  }
  .btn-item + .btn-item {
    border-top: 1px solid #ffffff;
  }
  .btn-item:hover {
    background-color: rgb(65, 126, 191);
  }
}
.right {
  width: calc(~"100% - 650px") !important;
}
.rightBox {
  width: 100%;
  height: calc(~"100% - 50px");
  border: 2px solid rgb(206, 210, 218);
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
  padding: 20px;
}
.leftBox {
  width: 619px !important;
  height: 260px;
  border: 2px solid rgb(206, 210, 218);
  border-radius: 8px;
  background: white;
  box-sizing: border-box;
}
.rightInput {
  margin-bottom: 20px;
}
</style>
